import {
    BoxIcon,
    BoxesIcon,
    CircleIcon,
    GripHorizontalIcon,
    GroupIcon,
    LightbulbIcon,
    MountainIcon,
    Settings2Icon,
    ShapesIcon,
    SplineIcon,
    TypeIcon,
    type LucideIcon
} from 'lucide-react';
import {DrawPolygonIcon, RingIcon} from '../shared/customIcons.ts';

const iconsByType: Record<string, LucideIcon> = {
    sphere: CircleIcon,
    icosphere: CircleIcon,
    disc: CircleIcon,
    box: BoxIcon,
    torus: RingIcon,
    torusKnot: RingIcon,
    cylinder: BoxIcon,
    plane: DrawPolygonIcon,
    extrudeShape: DrawPolygonIcon,
    lathe: DrawPolygonIcon,
    ground: MountainIcon,
    lines: GripHorizontalIcon,
    dashedLines: GripHorizontalIcon,
    tube: SplineIcon,
    model: BoxesIcon,
    text: TypeIcon,
    group: GroupIcon,
    pointLight: LightbulbIcon,
    directionalLight: LightbulbIcon,
    spotLight: LightbulbIcon,
    hemisphericLight: LightbulbIcon,
    sceneSettings: Settings2Icon
};

export default function sceneTypeIcon(type: string): LucideIcon {
    return iconsByType[type] ?? ShapesIcon;
}
